<script setup lang="ts">
import MultiSelectStores from '@/components/ui/MultiSelectStores.vue'
import useStore from '@/composables/store'

import type { LoyaltyReward } from '@/types/types'

const props = defineProps<{
  selectedReward: LoyaltyReward | null
  scopedStoreIds?: number[]
}>()

const storeIds = defineModel<number[]>('storeIds', { required: true })

const { t } = useI18n()
const { getStoresByPermission } = useStore()

const storesWithPermission = computed(() => getStoresByPermission('reward.read'))

const additionalStoreOptions = computed(() =>
  (props.selectedReward?.stores ?? []).map((store) => ({
    value: store.id,
    label: store.name
  }))
)
</script>

<template>
  <Card>
    <CardHeader>
      <CardTitle>{{ t('pages.offer.reward.storesTitle') }}</CardTitle>
    </CardHeader>
    <CardContent class="flex flex-col w-full">
      <label class="mb-1.5 block text-sm font-medium text-foreground">
        {{ t('pages.offer.reward.storesSubtitle') }}
      </label>
      <MultiSelectStores
        v-model="storeIds"
        :has-label="false"
        class="sm:w-full flex-1"
        :max-shown-items="3"
        :stores-with-permission="storesWithPermission"
        :additional-store-options="additionalStoreOptions"
        :scoped-store-ids="scopedStoreIds"
      />
    </CardContent>
  </Card>
</template>
